import { render, staticRenderFns } from "./v-hero-custom.vue?vue&type=template&id=dc90770c&scoped=true&"
import script from "./v-hero-custom.vue?vue&type=script&lang=js&"
export * from "./v-hero-custom.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-custom.vue?vue&type=style&index=0&id=dc90770c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc90770c",
  null
  
)

export default component.exports